import { render, staticRenderFns } from "./AddDataset.vue?vue&type=template&id=04516ba9&scoped=true&"
import script from "./AddDataset.vue?vue&type=script&lang=js&"
export * from "./AddDataset.vue?vue&type=script&lang=js&"
import style0 from "./AddDataset.vue?vue&type=style&index=0&id=04516ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04516ba9",
  null
  
)

export default component.exports